import { t } from '../../app/i18n';

export default {
  INFORMATIKA: 1,
  BANKOVNICTVO_FINANCIE: 2,
  TELEKOMUNIKACIE: 3,
  PRAVO: 4,
  VEDA_PORADENSTVO: 5,
  ENERGETIKA: 6,
  MEDIA_MARKETING: 7,
  POISTOVNICTVO: 8,
  SKOLSTVO_KULTURA: 9,
  STATNA_SPRAVA: 10,
  MALOOBCHOD_VELKOOBCHOD: 11,
  ZDRAVOTNICTVO: 12,
  LAHKY_PRIEMYSEL: 13,
  AUTOMOBILOVY_PRIEMYSEL: 14,
  POTRAVINARSKY_PRIEMYSEL: 15,
  POLICIA_ARMADA: 16,
  STAVEBNICTVO: 17,
  RESTAURACNE_UBYTOVACIE: 18,
  TAZKY_PRIEMYSEL: 19,
  POLNOHOSPODARSTVO: 20,
  DOPRAVA: 21,
  ADMINISTRATIVA: 22,
  SLUZBY: 23,
  INE: 24,
};

export const translation = {
  1: t('Informatika'),
  2: t('Bankovníctvo a financie'),
  3: t('Telekomunikácie'),
  4: t('Právo'),
  5: t('Veda a poradenstvo'),
  6: t('Energetika'),
  7: t('Médiá a marketing'),
  8: t('Poisťovníctvo'),
  9: t('Školstvo a kultúra'),
  10: t('Štátna správa'),
  11: t('Maloobchod a veľkoobchod'),
  12: t('Zdravotníctvo'),
  13: t('Ľahký priemysel'),
  14: t('Automobilový priemysel'),
  15: t('Potravinársky priemysel'),
  16: t('Polícia a armáda'),
  17: t('Stavebníctvo'),
  18: t('Reštauračné a ubytovacie služby'),
  19: t('Ťažký priemysel'),
  20: t('Poľnohospodárstvo'),
  21: t('Doprava'),
  22: t('Administratíva'),
  23: t('Služby'),
  24: t('Iné'),
};



// WEBPACK FOOTER //
// ./src/common/enums/sector.js